import { Navigate, useLocation } from "react-router-dom";
import { toAppPath } from "../../lib/appNavigation";
import { isPublicAppPath, isRouteObfuscationEnabled } from "../../lib/routeTokens";
import RedirectUnknown from "./RedirectUnknown";

/** Sends readable URLs (e.g. /dashboard) to their /du/... token equivalent. */
const LegacyPathTokenRedirect = () => {
  const location = useLocation();

  if (!isRouteObfuscationEnabled() || isPublicAppPath(location.pathname)) {
    return <RedirectUnknown />;
  }

  return (
    <Navigate
      to={toAppPath(`${location.pathname}${location.search || ""}`)}
      replace
      state={location.state}
    />
  );
};

export default LegacyPathTokenRedirect;
